import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import { saveAs } from "file-saver";

import template from "../../../../../assets/images/Loan_Pack_Documentation.docx";
import wg_template from "../../../../../assets/images/WG_Loan_Pack_Documentation_Issue.docx";


export const generateLoanDoc = async (data) => {
  

  // choose template
  const selectedTemplate = data.isWg == true || data.isWg == "true" ? wg_template : template;

  // download file name
  const fileName = data.isWg == true || data.isWg == "true"
    ? "WG-Loan-Pack-Documentation.docx"
    : "Loan-Pack-Documentation.docx";

  const res = await fetch(selectedTemplate);
  const content = await res.arrayBuffer();

  const zip = new PizZip(content);

  const doc = new Docxtemplater(zip, {
    paragraphLoop: true,
    linebreaks: true
  });

  doc.setData({
    hospital: data.hospital,
    name: data.name,
    date: data.date,
    sets: data.sets,
    po:data.po
  });

  doc.render();

  const blob = doc.getZip().generate({
    type: "blob",
    mimeType:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  });

  saveAs(blob, fileName);
};